// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__YMN7N","selected":"Chip_selected__3a8e1"};